import React from 'react';

import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import SignUpForm from './SignUpForm';
import {  PENDING } from '../../constants/authStatus';
import SignUpConfirm from './SignUpConfirm';

import pic from '../../assets/loginpage-img-light.png';
import titleLogo from '../../assets/lt_logo.png';
import titleLogo_dark from '../../assets/lt_logo_dark.png';
import ThemeTopSwitcher from '../ThemeTopSwitcher/ThemeTopSwitcher';

const SignUp = ({theme, setTheme}) => {
  const status = useSelector(state => state.userReducer.auth.status);

  const renderComponent = {
    [PENDING]: <SignUpConfirm theme={theme}/>,
    // [CHANGE]: <ChangeEmail />,
    '': <SignUpForm />
  };

  const handleThemeToggler = () =>{
    const newTheme = theme === 'dark-theme' ? 'light-theme' : 'dark-theme';
    setTheme(newTheme);
  };

  return (
    <div className="login-wrapper">
      <div className='theme-switcher-wrapper'>
        <ThemeTopSwitcher
          text={['DARK', 'LIGHT']}
          switcher={theme === 'dark-theme' ? 0 : 1}
          handleClick={handleThemeToggler}
        />
      </div>
      <div className="login-picture">
        <img src={pic} alt="login-picture" />
      </div>
      <div className="login-form">
        <div className="login-form-title">
        <img src={theme !== 'dark-theme' ? titleLogo : titleLogo_dark} alt="title logo" />
        </div>
        {renderComponent[status]}
      </div>
    </div>
  );
};

export default SignUp;

SignUp.propTypes = {
  theme: PropTypes.string,
  setTheme: PropTypes.func,
};